import styled from 'styled-components';

export const IPAddressSection = styled.section`
    color: #01606F;
    font-size: 40px;
    line-height: 58px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    justify-content: center;
    display: flex;
    height: 100vh;
    margin: 0 auto;
    align-items: center;
    text-align: center;
`;
